export default __webpack_public_path__ + "static/media/location-unavailable-desktop@2x.ab4b21ce.png";